import React, { Component } from "react"
import PropTypes from "prop-types"
import styled from "styled-components"
import { translate } from "react-i18next"
import PersonSVG from "./PersonSVG"
import ScoreShape from "../../../state/shapes/ScoreShape"

const TextDiv = styled.div`
  text-align: center;
  font-weight: bold;
`

class PeopleSection extends Component {
  getPersonSvg = (number, width, hexColor, percentage) => {
    let unique_id = this.props.identifier + "_" + number
    return <PersonSVG id={unique_id} width={width} hexColor={hexColor} percentage={percentage} />
  }

  drawPeople = (peopleNeeded, hexColor, scores) => {
    const width = 65 / peopleNeeded

    const people = []
    for (let i = 0; i < peopleNeeded; i++) {
      people.push(this.getPersonSvg(i, width, hexColor, Math.round(scores[i].percentage).toFixed(1)))
    }

    return people
  }

  render() {
    const { t, hexColor, percentage, totalPeople, peopleNeeded, scores } = this.props
    return (
      <div style={{ width: "100%" }}>
        <div className="hidden-sm-down">{this.drawPeople(peopleNeeded, hexColor, scores)}</div>
        <TextDiv style={{ color: hexColor }}>
          {Math.round(percentage)} %
          <br /> {totalPeople} {t("People")}
        </TextDiv>
      </div>
    )
  }
}

PeopleSection.propTypes = {
  identifier: PropTypes.string.isRequired,
  hexColor: PropTypes.string,
  percentage: PropTypes.any,
  totalPeople: PropTypes.number,
  peopleNeeded: PropTypes.number,
  scores: PropTypes.arrayOf(PropTypes.shape(ScoreShape)).isRequired,
}

export default translate()(PeopleSection)



// WEBPACK FOOTER //
// ./src/components/widgets/CustomNPS/PeopleSection.jsx